// extracted by mini-css-extract-plugin
module.exports = {"vertical-menu":"styles_vertical-menu__AglwV","vertical-menu__arrow":"styles_vertical-menu__arrow__U_4yA","is-active":"styles_is-active__ZC45Z"};